import { Button, MyTableComponent } from "components"
import { useTranslation } from "react-i18next"
import { Box } from "theme-ui"
import selecticon from "./selecticon.png"

export const EditMessages = () => {
 // language translator
 const { t } = useTranslation("translation")
 const data = [
  {
   infoone: "Liste mit UNSUSPEND wieder gestartet",
   infotwo: "1:60004",
   infothree: "Schwerer Fehler",
   infofour: "Betriebssystem/Firmware",
   infofive: 1,
  },
  {
   infoone: "Liste mit UNSUSPEND wieder gestartet",
   infotwo: "1:60004",
   infothree: "Schwerer Fehler",
   infofour: "Betriebssystem/Firmware",
   infofive: 2,
  },
  {
   infoone: "Liste mit UNSUSPEND wieder gestartet",
   infotwo: "1:60004",
   infothree: "Schwerer Fehler",
   infofour: "Betriebssystem/Firmware",
   infofive: 3,
  },
  {
   infoone: "Liste mit UNSUSPEND wieder gestartet",
   infotwo: "1:60004",
   infothree: "Schwerer Fehler",
   infofour: "Betriebssystem/Firmware",
   infofive: 4,
  },
 ]

 const columns = [
  { Header: t("designation"), accessor: "infoone" },
  { Header: "Member:oType", accessor: "infotwo" },
  { Header: t("severity"), accessor: "infothree" },
  { Header: t("category"), accessor: "infofour" },
  {
   Header: t("receiptRequired"),
   Cell: ({ row }: any) => (
    <div className="custom-checkbox">
     <input type="checkbox" id={row.original.infofive} />
     <label className="font-semibold font-sm Jakarta-font" htmlFor={row.original.infofive}></label>
    </div>
   ),
  },
 ]

 return (
  <div className="relative h-screen  md:h-screen lg:h-full w-[96%] mx-auto">
   <div className="flex lg:flex-row flex-col lg:justify-between lg:items-center mt-5 mb-4">
    <h1 className="Jakarta-font font-bold text-xl">{t("editMessages")}</h1>
    <div className="flex lg:flex-row flex-col lg:items-center">
     <div>
      <Button size={"doublexl"}>Forum Gera</Button>
     </div>
     <div className="lg:ml-2 py-2">
      <Button size={"doublexl"} color={"gray"}>
       Test Server
      </Button>
     </div>
    </div>
   </div>
   <Box bg="highlight" className="py-2 px-2">
    <Box bg="light_gray" className="flex justify-between  py-4 rounded mx-2 px-3 ">
     <div className="flex items-center">
      <div>
       <img className="rotate-[90deg]" src={selecticon} alt="selecticon" />
      </div>
      <h1 className="font-semibold font-sm Jakarta-font">1000 {t("events")}</h1>
     </div>

     <div className="custom-checkbox">
      <input type="checkbox" id="update" />
      <label className="font-semibold font-sm Jakarta-font" htmlFor="update">
       {t("updateAutomatically")}
      </label>
     </div>
    </Box>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent fullHeight={false} columns={columns} data={data} paginate={true} />
  </div>
 )
}
